import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Gallery01 from "../assets/gallery-01.png";
import Gallery02 from "../assets/gallery-02.png";
import Gallery03 from "../assets/gallery-03.png";
import Gallery04 from "../assets/gallery-04.png";

const GalleryModal = ({ show, onClose }) => {
  if (!show) return null;

  // Close if clicking on backdrop
  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal-backdrop-custom")) {
      onClose();
    }
  };

  return (
    <div
      className="modal-backdrop-custom gallery-slider"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1150,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
      }}
      onClick={handleBackdropClick}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        style={{ position: "relative", zIndex: 1100 }}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <div className="modal-content bg-dark">
          <div className="modal-body p-0 position-relative">
            {/* Close button */}
            <button
              type="button"
              className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
              aria-label="Close"
              onClick={onClose}
            ></button>

            {/* Swiper slider */}
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              spaceBetween={10}
              slidesPerView={1}
              className="gallery-swiper"
            >
              <SwiperSlide>
                <div className="gallery-img d-flex align-items-center justify-content-center">
                  <img src={Gallery01} alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="gallery-img">
                  <img src={Gallery02} alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="gallery-img">
                  <img src={Gallery03} alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="gallery-img">
                  <img src={Gallery04} alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="gallery-img">
                  <img src={Gallery01} alt="" />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;
